import { Component, OnInit } from '@angular/core';
import { Customer } from 'src/app/models/Customer';
import { blobList } from '../../../assets/content/blobLocations';
import { countryList } from '../../../assets/content/countries';
import { ModalController } from '@ionic/angular';
import {
  CalendarModal,
  CalendarModalOptions,
  DayConfig,
  CalendarResult
} from 'ion2-calendar';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-add-customer-modal',
  templateUrl: './add-customer-modal.page.html',
  styleUrls: ['./add-customer-modal.page.scss'],
})
export class AddCustomerModalPage implements OnInit {

  public countryList = countryList.sort((a, b) => (a.name > b.name) ? 1 : -1);
  public blobList = blobList;
  public customer: Customer;
  public isEditing: boolean;

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public customerService: CustomerService,
    public validationService: ValidationService
  ) { }

  ngOnInit() {
  }

  async openCalendar() {
    const options: CalendarModalOptions = {
      title: "Expiry Date",
      from: new Date(2019, 12, 1),
      defaultDate: new Date(this.customer.expiryDate).toISOString(),
      format: 'DD-MM-YYY',
      defaultScrollTo: this.customer.expiryDate,
      showYearPicker: true,
      cssClass: "calendar-holder"
    };

    const myCalendar = await this.modalController.create({
      component: CalendarModal,
      componentProps: { options }
    });

    myCalendar.present();

    const event: any = await myCalendar.onDidDismiss();
    const date: CalendarResult = event.data;
    if (date) {
      this.customer.expiryDate = new Date(date.string);
    }

  }

  closeModal() {
    this.modalController.dismiss();
  }

  async saveCustomer(event) {
    this.unfocusService.unfocus(event);
    if (this.validationService.isCustomerValid(this.customer)) {
      if (this.isEditing) {
        this.customerService.updateExistingCustomer(this.customer).then(x => {
          this.modalController.dismiss();
        });
      }
      else {
        this.customerService.addCustomer(this.customer).then(x => {
          this.modalController.dismiss();
        })
      }
    }
    else {
      await this.validationService.alertForCustomerErrors(this.customer);
    }
  }

}
